/**
 * Partnership eligibility configuration for Long-Term Care Partnership states.
 * Derived from carrier requirements: Partnership benefit requirements_CareScout insurance - Minimum Requirements.csv
 *
 * Inflation requirements by state and age band (DRA rules):
 * - Age 18–60: Compound inflation required (state-specific minimum %)
 * - Age 61–75: Inflation required (state-specific minimum %)
 * - Age 76+: Inflation protection not required (any option qualifies)
 */

export interface PartnershipBandConfig {
  age: { min: number; max: number };
  inflations: { min: number; max: number };
  compoundRequired?: boolean;
}

export type PartnershipStateConfig = PartnershipBandConfig[];

export const AGE_NO_INFLATION_REQUIRED = 76;

export const partnershipStateConfig: Record<string, PartnershipStateConfig> = {
  AL: [
    { age: { min: 18, max: 60 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
  AZ: [
    { age: { min: 18, max: 60 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
  AR: [
    { age: { min: 18, max: 60 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
  ],
  DE: [
    { age: { min: 18, max: 60 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
  ],
  GA: [
    { age: { min: 18, max: 60 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
  ID: [
    { age: { min: 18, max: 60 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
  IA: [
    { age: { min: 18, max: 60 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
  ],
  KS: [
    { age: { min: 18, max: 60 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
  KY: [
    { age: { min: 18, max: 60 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
  ],
  LA: [
    { age: { min: 18, max: 60 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
  MD: [
    { age: { min: 18, max: 60 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
  MI: [
    { age: { min: 18, max: 60 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
  MO: [
    { age: { min: 18, max: 60 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
  MT: [
    { age: { min: 18, max: 60 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
  NV: [
    { age: { min: 18, max: 60 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
  NM: [
    { age: { min: 18, max: 60 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
  NC: [
    { age: { min: 18, max: 60 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
  ND: [
    { age: { min: 18, max: 60 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
  OH: [
    { age: { min: 18, max: 60 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
  OK: [
    { age: { min: 18, max: 60 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
  ],
  RI: [
    { age: { min: 18, max: 60 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
  SC: [
    { age: { min: 18, max: 60 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
  ],
  SD: [
    { age: { min: 18, max: 60 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
  TN: [
    { age: { min: 18, max: 60 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
  TX: [
    { age: { min: 18, max: 60 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
  VA: [
    { age: { min: 18, max: 60 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
  ],
  WV: [
    { age: { min: 18, max: 60 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
  WI: [
    { age: { min: 18, max: 60 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 3, max: 5 }, compoundRequired: true },
  ],
  WY: [
    { age: { min: 18, max: 60 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
    { age: { min: 61, max: 75 }, inflations: { min: 1, max: 5 }, compoundRequired: true },
  ],
};

export const PARTNERSHIP_STATES = Object.keys(partnershipStateConfig);
